import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { showAlertSnackbar } from '../../../reducers/uiSlice';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: "100%"
        },
        minWidth: 1200
    },
    rowTitle: { 
        fontSize: "1.2rem", 
        backgroundColor: "#303030"
    },
    rowRightBorder: { 
        borderLeft: "1px solid #5F5F5F"
    },
    rowContent: {
        marginTop: 10,
        backgroundColor: "rgba(255, 255, 255, 0.08)"
    },
    selectStyle: {
        marginLeft: 8
    }
}));

function UserAuth(props) {
    const classes = useStyles();
    const {t} = useTranslation('slotAssignment');
    const dispatch = useDispatch();

    const [open, setOpen] = useState(true);

    const [values, setValues] = useState({     
        password: '',
        showPassword: false,
    });

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
    };
    const handleClickShowPassword = () => {
        setValues({ ...values, showPassword: !values.showPassword });
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleClose = () => {
        setOpen(false);
    };

    // Hard coding temporally
    function handleSubmitPwd() {       
        if(values.password === 's005t') {
            handleClose(false);
            props.setHidden(false);
        } else {
            dispatch(showAlertSnackbar({message: t('pwd_fail_message'), type: 'error'}))
        }              
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{t('pwd')}</DialogTitle>
                <DialogContent>
                    <FormControl className={clsx(classes.margin, classes.textField)}>
                        <InputLabel htmlFor="standard-adornment-password">{t('password')}</InputLabel>
                        <Input
                            id="standard-adornment-password"
                            type={values.showPassword ? 'text' : 'password'}
                            value={values.password}
                            onChange={handleChange('password')}
                            endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                >
                                {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                            </InputAdornment>
                            }
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Link to='/main'>
                        <Button onClick={handleClose} color="primary">
                            {t('cancel')}
                        </Button>
                    </Link>                   
                    <Button onClick={handleSubmitPwd} color="primary">
                        {t('confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default UserAuth;